// extracted by mini-css-extract-plugin
export default {"container":"LUmmV","userTitle":"yEjao","userDetails":"Y6FNM","userName":"_0V0Bp","rewards":"dTYPI"};